<ng-container *transloco="let t">
  @if ((conditionVariants$ | async) && (productOptions$ | async)) {
    <span class="fixed-space-8" aria-hidden="true"></span>
    <div class="flex">
      @if (showLabel) {
        <h2 class="label text-gray-05">{{ t('label_condition') }}</h2>
        <span class="fixed-space-4" aria-hidden="true"></span>
      }
      <button (click)="onShowConditionInfo()" class="popsy-button-icon info">
        <popsy-icon-information-circle
          class="icon gray-dark"></popsy-icon-information-circle>
      </button>
    </div>
    <span class="fixed-space-4" aria-hidden="true"></span>
    @if (availableConditions$ | async; as availableConditions) {
      <nav
        class="product-condition-variants-component"
        [class.mobile]="(biggerThan$ | async)?.xs"
        [class.widescreen]="(biggerThan$ | async)?.mobileL">
        <ul class="flex flex-row variant-list">
          <!-- FAIR Condition -->
          @if (newBatterySelected() ? 'FAIR_NEW_BATTERY' : 'FAIR'; as fairCondition) {
            <li
              class="flex flex-col variant-card"
              [class.selected]="
                availableConditions[fairCondition]?.id === id &&
                availableConditions[fairCondition]?.inStock
              "
              [class.not-stock]="!availableConditions[fairCondition]?.inStock">
              <div
                class="link popsy-negative mid-gray"
                (click)="onSelectVariant(availableConditions[fairCondition]?.id || '')">
                <span class="small bold"
                  >{{ t(getTransLabel(fairCondition)) || '' }}
                </span>
                @if (availableConditions[fairCondition]?.inStock) {
                  <span class="small"
                    >{{ (availableConditions[fairCondition]?.price | amount) || '-' }}
                  </span>
                }
                @if (
                  !availableConditions[fairCondition] ||
                  !availableConditions[fairCondition]?.inStock
                ) {
                  <span class="small" [class.out]="!(biggerThan$ | async)?.xs"
                    >{{ t('label_out_of_stock') }}
                  </span>
                }
              </div>
            </li>
          }
          <!-- GOOD Condition -->
          @if (newBatterySelected() ? 'GOOD_NEW_BATTERY' : 'GOOD'; as goodCondition) {
            <li
              class="flex flex-col variant-card"
              [class.selected]="
                availableConditions[goodCondition]?.id === id &&
                availableConditions[goodCondition]?.inStock
              "
              [class.not-stock]="!availableConditions[goodCondition]?.inStock">
              <div
                class="link popsy-negative mid-gray"
                (click)="onSelectVariant(availableConditions[goodCondition]?.id || '')">
                <span class="small bold"
                  >{{ t(getTransLabel(goodCondition)) || '' }}
                </span>
                @if (availableConditions[goodCondition]?.inStock) {
                  <span class="small"
                    >{{ (availableConditions[goodCondition]?.price | amount) || '-' }}
                  </span>
                }
                @if (
                  !availableConditions[goodCondition] ||
                  !availableConditions[goodCondition]?.inStock
                ) {
                  <span class="small" [class.out]="!(biggerThan$ | async)?.xs"
                    >{{ t('label_out_of_stock') }}
                  </span>
                }
              </div>
            </li>
          }
          <!-- EXCELLENT Condition -->
          @if (
            newBatterySelected() ? 'EXCELLENT_NEW_BATTERY' : 'EXCELLENT';
            as excellentCondition
          ) {
            <li
              class="flex flex-col variant-card"
              [class.selected]="
                availableConditions[excellentCondition]?.id === id &&
                availableConditions[excellentCondition]?.inStock
              "
              [class.not-stock]="!availableConditions[excellentCondition]?.inStock">
              <div
                class="link popsy-negative mid-gray"
                (click)="
                  onSelectVariant(availableConditions[excellentCondition]?.id || '')
                ">
                <span class="small bold"
                  >{{ t(getTransLabel(excellentCondition)) || '' }}
                </span>
                @if (availableConditions[excellentCondition]?.inStock) {
                  <span class="small"
                    >{{
                      (availableConditions[excellentCondition]?.price | amount) || '-'
                    }}
                  </span>
                }
                @if (
                  !availableConditions[excellentCondition] ||
                  !availableConditions[excellentCondition]?.inStock
                ) {
                  <span class="small" [class.out]="!(biggerThan$ | async)?.xs"
                    >{{ t('label_out_of_stock') }}
                  </span>
                }
                @if (checkGoodDeal()) {
                  <span class="good-deal">{{ t('label_good_deal') }} </span>
                }
              </div>
            </li>
          }
        </ul>
        <!-- NEW_BATTERY Conditions -->
        @if (showBatteryCondition()) {
          <div
            class="flex flex-col variant-card battery-grid"
            [class.selected]="newBatterySelected()"
            [class.not-stock]="!isNewBatteryAvailable()">
            <div
              class="arrow-up"
              [class.fair]="
                availableConditions['FAIR']?.id === id ||
                availableConditions['FAIR_NEW_BATTERY']?.id === id
              "
              [class.good]="
                availableConditions['GOOD']?.id === id ||
                availableConditions['GOOD_NEW_BATTERY']?.id === id
              "
              [class.excellent]="
                availableConditions['EXCELLENT']?.id === id ||
                availableConditions['EXCELLENT_NEW_BATTERY']?.id === id
              "></div>
            <div
              class="link battery-selector popsy-negative mid-gray flex"
              (click)="isNewBatteryAvailable() ? swithcBatterySelected() : null">
              <popsy-icon-spec-battery
                class="icon battery"
                [class.rtl]="isRtl$ | async"></popsy-icon-spec-battery>
              <span class="fixed-space-8" aria-hidden="true"></span>
              <span class="small">{{ t('action_add_battery') }} </span>
              <button (click)="onShowBatteryInfo($event)" class="popsy-button-icon info">
                <popsy-icon-information-circle
                  class="icon gray-02"
                  [class.gray-03]="
                    !isNewBatteryAvailable()
                  "></popsy-icon-information-circle>
              </button>
              <span class="dynamic-space" aria-hidden="true"></span>
              <label [class.active]="newBatterySelected()"></label>
              @if (newBatterySelected()) {
                <div class="progress" [class.progress__bar]="newBatterySelected()"></div>
              }
            </div>
          </div>
        }
      </nav>
    }
  }
</ng-container>
